// Paso del deslizamiento automático de una fila que no cabe: va y viene despacio y descansa en cada orilla.
// Puro, sin React.

/** Velocidad en px por segundo. */
export const AUTO_SCROLL_SPEED = 14;
/** Descanso en cada orilla, en milisegundos. */
export const AUTO_SCROLL_REST_MS = 1_600;

export interface AutoScrollState {
    offset: number;
    direction: 1 | -1;
    restLeftMs: number;
}

export const AUTO_SCROLL_START: AutoScrollState = {
    offset: 0,
    direction: 1,
    restLeftMs: AUTO_SCROLL_REST_MS,
};

/** Avanza `elapsedMs`; al tocar una orilla da la vuelta y descansa. */
export function stepAutoScroll(
    state: AutoScrollState,
    maxOffset: number,
    elapsedMs: number,
): AutoScrollState {
    if (maxOffset <= 0) return { ...AUTO_SCROLL_START, restLeftMs: state.restLeftMs };
    if (state.restLeftMs > 0) {
        return { ...state, restLeftMs: Math.max(0, state.restLeftMs - elapsedMs) };
    }
    const next = state.offset + state.direction * AUTO_SCROLL_SPEED * (elapsedMs / 1_000);
    if (next >= maxOffset)
        return { offset: maxOffset, direction: -1, restLeftMs: AUTO_SCROLL_REST_MS };
    if (next <= 0) return { offset: 0, direction: 1, restLeftMs: AUTO_SCROLL_REST_MS };
    return { ...state, offset: next };
}

/** Qué orillas esconden contenido, para el desvanecido. */
export function hiddenEdges(
    scrollLeft: number,
    scrollWidth: number,
    clientWidth: number,
): { start: boolean; end: boolean } {
    const max = scrollWidth - clientWidth;
    if (max <= 1) return { start: false, end: false };
    return { start: scrollLeft > 1, end: scrollLeft < max - 1 };
}

/** Donde descansa al final: el inicio de la primera burbuja que deja ver la última completa. */
export function snappedMax(starts: readonly number[], naturalMax: number): number {
    if (naturalMax <= 0) return 0;
    const snap = starts.find((start) => start >= naturalMax);
    return snap ?? naturalMax;
}

/** Qué orillas cortan una burbuja a la mitad, para desvanecer solo esas. */
export function cutEdges(
    boxes: readonly { left: number; width: number }[],
    scrollLeft: number,
    clientWidth: number,
): { start: boolean; end: boolean } {
    const right = scrollLeft + clientWidth;
    return {
        start: boxes.some((b) => b.left < scrollLeft - 1 && b.left + b.width > scrollLeft + 1),
        end: boxes.some((b) => b.left < right - 1 && b.left + b.width > right + 1),
    };
}
